export default angular
    .module("app.layout", []);
